import React from 'react';
import PropTypes from 'prop-types';
import Dialog from "../overlay/Dialog";
import OverlayController from "../overlay/OverlayController";
import SelectField from "material-ui/SelectField";
import MenuItem from "material-ui/MenuItem";
import TextField from "../material/TextField";
import mutationsWorkflow from "../../graphql/mutationsWorkflow";
import { compose } from 'react-apollo';
import _ from 'lodash';

export default compose(
    mutationsWorkflow.createTransitionEventMutationHoc
)(class TransitionEventSelectDialog extends React.Component {

    static propTypes = {
        project: PropTypes.object.isRequired,
        transitionEventId: PropTypes.string,
        callback: PropTypes.func.isRequired,
        createTransitionEvent: PropTypes.func.isRequired,
    };

    static defaultProps = {
        transitionEventId: null
    };

    constructor(props) {
        super(props);

        this.state = {
            eventId: this.props.transitionEventId || null,
            eventName: ''
        };
    }

    onEventIdChange = (event, index, value) => {
        this.setState({
            eventId: value,
            eventName: ''
        });
    };

    onEventNameChange = (event) => {
        this.setState({
            eventId: null,
            eventName: event.target.value
        });
    };

    onSubmit(event) {
        event.preventDefault();
        if (this.state.eventId) {
            let transitionEvent = _.find(this.props.project.transitionEvents, {id: this.state.eventId});
            OverlayController.hideOverlay();
            this.props.callback(transitionEvent);
        } else {
            OverlayController.showActivityIndicator();
            this.props.createTransitionEvent(this.props.project.id, {name: this.state.eventName})
                .then(({data}) => {
                    OverlayController.hideActivityIndicator();
                    OverlayController.hideOverlay();
                    this.props.callback(data.createTransitionEvent);
                })
                .catch((error) => {
                    console.log(error);
                    OverlayController.hideActivityIndicator();
                    OverlayController.showErrorAlert(error);
                });
        }
    }

    onCancel = () => {
        OverlayController.hideOverlay();
        this.props.callback(null);
    };

    isEnabled() {
        let isEventNameValid = this.state.eventName.trim().length > 0;
        let isStateIdValid = this.state.eventId !== null;
        return isEventNameValid || isStateIdValid;
    }

    render() {
        let actions = [
            {label: 'Cancel', handler: this.onCancel},
            {label: 'Done', type: "submit", form: 'transitionEventSelectDialogForm', disabled: !this.isEnabled()}
        ];
        return (
            <Dialog showTitleBar={true} title={`Select Transition Event`} actions={actions} className="transitionEventSelectDialog">
                <form onSubmit={event => this.onSubmit(event)} id="transitionEventSelectDialogForm">
                    <SelectField
                        className="custom-field custom-select-field"
                        fullWidth={true}
                        floatingLabelText="Select Event"
                        floatingLabelFixed={true}
                        hintText="Choose transition event"
                        value={this.state.eventId}
                        onChange={this.onEventIdChange}
                    >
                        <MenuItem value={null} primaryText=""/>
                        {this.props.project.transitionEvents.map(event =>
                            <MenuItem key={event.id} value={event.id} primaryText={event.name}/>
                        )}
                    </SelectField>
                    Or create a new event
                    <TextField
                        labelText="Event Name"
                        floatingLabel={true}
                        placeholderText="Enter name to create new event"
                        value={this.state.eventName}
                        onChange={this.onEventNameChange}/>
                </form>
            </Dialog>
        );
    }
});



// WEBPACK FOOTER //
// ./src/components/diagram/TransitionEventSelectDialog.js